export const siteSettings = {
  name: "Magnate Markets",
  link: "https://magnatemarkets.net",
  email: "support@magnatemarkets.net",
  appLink: "https://app.magnatemarkets.net",
};
